import { cn } from "@utils/tw"
import { ReactNode } from "react"

export const AdminMessage = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    env.admin && (
      <div className={cn("w-full flex justify-center", className)}>
        <pre className="flex flex-col gap-2 items-center justify-center bg-grey-0 px-3 pb-3 rounded-md border-grey-2 border text-grey-2 opacity-60 type-ui-label text-wrap">
          <span className="flex text-[0.75em] w-full text-left underline underline-offset-2">ADMIN MESSAGE</span>
          {children}
        </pre>
      </div>
    )
  )
}
